import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxTimelineEvent, NgxTimelineModule } from '@frxjs/ngx-timeline';
import { TimelineService } from '../../core/services/timeline.service';
import { TimelineContainer } from '../../core/models/timeline-container.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-timeline-container',
  standalone: true,
  imports: [CommonModule, NgxTimelineModule, MatButtonModule, MatCardModule, RouterModule],
  templateUrl: './timeline-container.component.html',
  styleUrls: ['./timeline-container.component.scss'],
})
export class TimelineContainerComponent implements OnInit {
  containerId!: number;
  header: any;
  events: NgxTimelineEvent[] = [];

  constructor(
    private route: ActivatedRoute,
    private timelineService: TimelineService,
  ) {}

  ngOnInit(): void {
    this.containerId = +this.route.snapshot.paramMap.get('id')!;
    this.loadTimelineEvents();
  }

  loadTimelineEvents(): void {
    this.timelineService
      .getContainerTimelineEvents(this.containerId)
      .subscribe((data: TimelineContainer) => {
        this.header = data.header;
        this.events = data.timeline.map((event: any) => ({
          ...event,
          timestamp: new Date(event.timestamp),
          description: `Estado: ${event.state}\nObservaciones: ${event.observations}`,
        }));
      });
  }
}
